import React, { useState, useEffect } from "react";
import { useHistory } from 'react-router-dom';
import {
  useDisclosure,
  VStack,
  Grid,
  Box,
  Flex,
  Spacer,
  useToast,
  Text,
  Divider,
  Button,
  Icon,
  Switch
} from "@chakra-ui/react";
import { AgGridColumn, AgGridReact } from "ag-grid-react";
import { format } from "date-fns";

import { FaFileCsv } from "react-icons/fa";

import CreateCaseButton from "../merchant-list/create-case-button-renderer";
import CreateCaseForm from "../Cases/create-case-form";
import Sidebar from "../sections/Sidebar/Sidebar";
import CaseService from "../../services/cases.service";
import BreadCrumbs from '../common/BreadCrumbs'
import Loader from '../common/Loader'; 
import Header from  '../sections/Header';
import CommentSearch from "./CommentSearch";
import CaseAction from "./CaseAction"

import { thousandSeparator } from "../../utils/utilities";
import { filterParams , dateComparator } from '../../utils/ag-grid';
import { getCountryNameWithCountryCode } from '../../config/static/country';

import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "./case.css";

const ListCases = () => {
  const toast = useToast();
  const history = useHistory();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [selectedcase, setselectedCase] = useState('');
  const [caseData, setRowData] = useState([]);
  const [isLoading, setisLoading] = useState(false);
  const [gridApi, setGridApi] = useState(null);
  const [actionList , setActionList] = useState([{ label: "Select the action", value: ""}])
  const [dateColumns,setDateColumns] = useState([]);
  const preferences = JSON.parse(localStorage.getItem("preferences"));
  const [oldCaseData,setOldCaseData] = useState([]);
  const caseView = preferences.caseView;

  const defaultColDef = {
    sortable: true,
    resizable: true,
    filter: true,
    editable: false
  };

  const onGridReady = (params) => {
    setGridApi(params.api);
  };

  const onFirstDataRendered = (params) => {
    params.api.sizeColumnsToFit();
  };
  const openModal = (data) => {
    setselectedCase({_id:data.merchantObjID,case:[{_id:data._id}]});
    onOpen();
  };
  
  const initialFetch = async () => {
    setisLoading(true);
    if (gridApi) gridApi.showLoadingOverlay();
    let result = await CaseService.fetchAll();
    if (result.error) {
      setisLoading(false);
      if (gridApi) gridApi.hideOverlay();
      toast({
        title: result.error,
        position: "top",
        status: "error",
        isClosable: true,
      });
      return;
    }
    setRowData(result);
    setOldCaseData(result)
    setisLoading(false);
    if (gridApi) (result && result.length) ? gridApi.hideOverlay() : gridApi.showNoRowsOverlay();
  };
  
  useEffect(() => {
    setActionList(prev => [...prev,{ label: "EDIT", value: "EDIT" }]);
    let user = localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")) : {};
    if (user.user && user.user.role && user.user.permissions.includes('deleteCase'))   
      setActionList(prev => [...prev,{ label: "DELETE", value: "DELETE" }]);
    initialFetch();
    setDateColumns(caseView.reduce((c,i)=>{
      if(i.type === "date")
        return [...c,i.value]
      return c;  
    },[]))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const dynamicCellStyle = (params) => {
    const ret = { textAlign: "centre" };
    if (
      typeof params.data[params["colDef"].field] !== "undefined" &&
      params.data[params["colDef"].field].hasOwnProperty("bg")
    )
      return {
        ...ret,
        backgroundColor: params.data[params["colDef"].field].bg,
      };
    return ret;
  };
  const cellUpdateForDate = (props) => {
    // const field = props["colDef"]["field"];
    if (typeof props["value"] !== "undefined") {
      let value = format(new Date(props["value"]), "dd-MMM-yyyy");
      return value;
    }
    return;
  };
  
  const cellUpdateForCountry = (props) => {
    return getCountryNameWithCountryCode(props["value"]);
  };

  //this will update the current edited row with updated data.
  const updateCase = (casedata) => {
    gridApi.getRowNode(casedata._id).setData(casedata);
    return;
  };

  const exportAsCSV = ()=>{
    toast({
      title: "Downloading inprogress..",
      position: "top",
      status: "info",
      isClosable: true,
      duration:1000
    });
    const  params = {
      // columnKeys:caseView.reduce((c,i)=>{return [...c,i.value]},[]),
      processCellCallback: (param)=>{
        if(dateColumns.includes(param.column.colId) && !isNaN(new Date(param.value))){
          return format(new Date(param.value), "dd-MMM-yyyy");
        }
        if(param.column.userProvidedColDef.headerName === "Trigger Types"){
          let selectedColumns = param.node.data.selectedColumns;
          return selectedColumns.reduce((c,d)=>{
              let triggerValue = d.triggerValue
              ? !isNaN(d.triggerValue) 
                ? 
                  d.datatype === 'percentage' 
                  ?
                    d.isExactValueRequired       
                    ?
                      `${(d.triggerValue * 100).toFixed(2)}%`
                    :
                      `${Math.round(d.triggerValue * 100)}%` 
                  :
                    d.datatype === 'currency'
                    ?   
                      `${d.symbol}${thousandSeparator(d.triggerValue)}`
                    :
                      thousandSeparator(d.triggerValue)
                : 
                  d.triggerValue
              : 
                ""
              return `${c}${d.label}:${triggerValue}\n`
          },'')
        }
        return param.value;
      },
      fileName: "cases.csv"
    };
    gridApi.exportDataAsCsv(params);
    return;
  }

  const onSearch = async (search='')=>{
    setisLoading(true);
    if(search === ''|| search === null){
      setRowData(oldCaseData);
      setisLoading(false);
      return;
    }
    let data = await CaseService.search({q:search});
    if (data.error) {
      toast({
        title: data.error,
        position: "top",
        status: "error",
        isClosable: true,
      });
      setisLoading(false);
      return;
    } 
    if (data.warning) {
      toast({
        title: data.warning,
        position: "top",
        status: "warning",
        isClosable: true,
      });
      setisLoading(false);
      return;
    }
    setRowData(data);
    setisLoading(false);
  }
  let editClass = {
    'align-items': 'center',
    'justify-content': 'center',
    'display': 'flex'
  }
  return (
    <Box>
      <Flex >
        <Box>
          <Sidebar />
        </Box>
        <Box w="100%">
          <Loader isLoading={isLoading} />
          <Header>
            <CaseAction setisLoading={setisLoading} gridApi={gridApi} actionList={actionList}/>
            <CommentSearch onSearch={onSearch}/>
            <Divider pr={2} h="60px" orientation="vertical" />
            <Button
              m={2}
              mr={4}
              fontSize={".8rem"}
              borderWidth={'1px'} 
              borderColor={'rgb(94,94,114,.3)'} 
              size="md"
              rightIcon={<Icon as={FaFileCsv} />}
              onClick={exportAsCSV}
            >
              Export as CSV
            </Button>
          </Header>
          <Flex  pl="2" pb="2" > 
            <BreadCrumbs /> 
            <Spacer/>
            <Flex pr={5} style={{'display': 'flex','justifyContent': 'center', 'alignItems': 'center'}} >
              <Text pr={2} >Weekly View </Text>
              <Switch id="email-alerts" isChecked={false} onChange={(e)=> {history.push('cases-group-by-week')}} />
            </Flex>
          </Flex>
          <Box>
            <Grid minH="87vh" pl={3} pr={2}>
              <VStack spacing={8}>
                <div
                  style={{ height: "100%", width: "100%" }}
                  className="ag-theme-alpine"
                >
                  {isOpen && (
                    <CreateCaseForm
                      isOpen={isOpen}
                      onOpen={onOpen}
                      onClose={onClose}
                      merchant={selectedcase}
                      action="view"
                      updateChange={updateCase}
                    />
                  )}
                  <AgGridReact
                    rowData={caseData}
                    rowSelection="multiple"
                    frameworkComponents={{
                      createCase: CreateCaseButton,
                      createTriggerTypes: (params)=>{
                      return(
                        <Box>
                          {params.data && params.data.selectedColumns.map(d=>(
                            <Box key={d.value} className={'triggerTypesDiv'}> <Text>{d.value} : {d.triggerValue
                                ? !isNaN(d.triggerValue) 
                                  ? 
                                    d.datatype === 'percentage' 
                                    ?
                                      d.isExactValueRequired       
                                      ?
                                        `${(d.triggerValue * 100).toFixed(2)}%`
                                      :
                                        `${Math.round(d.triggerValue * 100)}%` 
                                    :
                                      d.datatype === 'currency'
                                      ?   
                                        `${d.symbol}${thousandSeparator(d.triggerValue)}`
                                      :
                                        thousandSeparator(d.triggerValue)
                                  : 
                                    d.triggerValue
                                : 
                                  ""
                              } </Text></Box>
                          ))
                          }
                        </Box>
                      )
                      }
                    }}
                    defaultColDef={defaultColDef}
                    pagination={true}
                    paginationPageSize={17}
                    onGridReady={onGridReady}
                    onFirstDataRendered={onFirstDataRendered}
                    // onSelectionChanged={onSelectionChanged}
                    getRowNodeId={ (data) => data._id }
                  >
                   {actionList.length>1 &&
                   (<AgGridColumn
                      width={50}
                      sortable={false}
                      filter={false}
                      headerCheckboxSelection={true}
                      checkboxSelection={true}
                      headerCheckboxSelectionFilteredOnly={true}
                      lockPosition={true}
                      pinned='left'
                    />)
                    }
                    <AgGridColumn
                      width={50}
                      cellRenderer="createCase"
                      cellRendererParams={{ onClick: openModal, label: "view" }}
                      sortable={false}
                      filter={false}
                      lockPosition={true}
                      cellStyle={editClass}
                      pinned='left'
                    />
                    <AgGridColumn 
                      headerName="Case Id"
                      field="_id" 
                      cellStyle={dynamicCellStyle} 
                      lockPosition={true}
                    />
                    <AgGridColumn
                      field="Merchant Legal Name"
                      cellStyle={dynamicCellStyle}
                      lockPosition={true}
                    />
                    <AgGridColumn
                      field="Merchant"
                      cellStyle={dynamicCellStyle}
                      lockPosition={true}
                    />
                    <AgGridColumn
                      headerName="Trigger Types"
                      //field="triggerTypes"
                      cellRenderer="createTriggerTypes"
                      autoHeight={true}
                      wrapText={true}
                      lockPosition={true}
                      rowSpan={rowSpan}
                      width={320}
                    />
                    <AgGridColumn
                      headerName="Manager"
                      field="manager"
                      cellStyle={dynamicCellStyle}
                    />
                    <AgGridColumn
                      headerName="Uploaded Date"
                      field="uploadedDate"
                      cellStyle={dynamicCellStyle}
                      cellRenderer={cellUpdateForDate}
                      comparator={dateComparator}
                      filter="agDateColumnFilter"
                      filterParams={filterParams}
                    />
                    <AgGridColumn 
                      headerName="Status" 
                      field="status" 
                      cellStyle={dynamicCellStyle}   
                    />
                    <AgGridColumn
                      headerName="File Date"
                      field="fileDate"
                      cellStyle={dynamicCellStyle}
                      comparator={dateComparator}
                      cellRenderer={cellUpdateForDate}
                      filter="agDateColumnFilter"
                      filterParams={filterParams}
                    />
                    <AgGridColumn
                      headerName="Created Date"
                      field="createdDate"
                      cellStyle={dynamicCellStyle}
                      cellRenderer={cellUpdateForDate}
                      comparator={dateComparator}
                      filter="agDateColumnFilter"
                      filterParams={filterParams}
                    />
                    <AgGridColumn
                      headerName="Reminder Date"
                      field="reminderDate"
                      cellStyle={dynamicCellStyle}
                      cellRenderer={cellUpdateForDate}
                      comparator={dateComparator}
                      filter="agDateColumnFilter"
                      filterParams={filterParams}
                    />
                    <AgGridColumn
                      headerName="Country"
                      field="fileCountry"
                      cellRenderer={cellUpdateForCountry}
                      cellStyle={dynamicCellStyle}
                    />
                    {/* {caseView.map((item) =>
                      item.type ==='date' ? (
                        <AgGridColumn
                          key={item.value}
                          headerName={item.label}
                          field={item.value}
                          cellStyle={dynamicCellStyle}
                          cellRenderer={cellUpdateForDate}
                          comparator={dateComparator}
                          filter="agDateColumnFilter"
                          filterParams={filterParams}
                          lockPosition={true}
                        ></AgGridColumn>
                      ) : 
                      (item.type ==='number' ?
                        (<AgGridColumn
                          key={item.value}
                          headerName={item.label}
                          field={item.value}
                          filter="agNumberColumnFilter"
                          cellStyle={dynamicCellStyle}
                          lockPosition={true}
                        ></AgGridColumn>)
                        :
                        (<AgGridColumn
                          key={item.value}
                          headerName={item.label}
                          field={item.value}
                          cellStyle={dynamicCellStyle}
                          lockPosition={true}
                        ></AgGridColumn>)
                      )
                    )} */}
                  </AgGridReact>
                </div>
              </VStack>
            </Grid>
          </Box>
        </Box>
      </Flex>
    </Box>
  );
};

export default ListCases;

function rowSpan(params) {
  if (params.data && params.data.selectedColumns && params.data.selectedColumns.length) {
    return params.data.selectedColumns.length;
  } else {
    return 1;
  }
}